<template>
  <div id="adTempMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>广告模板设置</el-breadcrumb-item>
          <el-breadcrumb-item>广告模板管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22">
        <el-form :inline="true"
                 class="pageSearch">
          <el-form-item label="模板名称::">
            <el-input placeholder="请输入广告模板名称"
                      v-model="pageSearch.name"
                      class="input-with-select">
              <!--<el-button slot="append" icon="el-icon-search" @click="bindQuery"></el-button>-->
            </el-input>
          </el-form-item>
          <el-form-item label="用户分组::">
            <el-input placeholder="请输入用户分组"
                      v-model="pageSearch.title"
                      class="input-with-select">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       size="small"
                       @click="bindQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2"
              class="searchRowAdd">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-edit"
                   v-if="is_edit"
                   @click="handleAdd">新增模板
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="pageList"
                border
                highlight-current-row
                v-loading="loading"
                style="width: 100%"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                         width="50"
                         label="序号"
                         :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fOpLastTime"
                         width="180"
                         label="最后操作时间">
        </el-table-column>
        <el-table-column prop="fGrpName"
                         label="用户分组">
        </el-table-column>
        <el-table-column prop="fLcdTmpName"
                         label="模板名称">
        </el-table-column>
        <el-table-column prop="fSwitchTime"
                         label="切换时间">
        </el-table-column>
        <el-table-column prop="fAdTitle"
                         label="广告标题">
        </el-table-column>
        <el-table-column prop="fIsShowSpaceNumStr"
                         label="车位数">
        </el-table-column>
        <el-table-column prop="fIsShowDurationStr"
                         label="停车时长">
        </el-table-column>
        <el-table-column prop="fIsShowInTimeStr"
                         label="进场时间">
        </el-table-column>
        <el-table-column prop="fIsShowCalcAmtStr"
                         label="计费金额">
        </el-table-column>
        <el-table-column prop="fIsShowDedAmtStr"
                         label="优惠金额">
        </el-table-column>
        <el-table-column prop="fIsShowAliPayIconStr"
                         label="支付宝图标">
        </el-table-column>
        <el-table-column prop="fIsShowWxIconStr"
                         label="微信图标">
        </el-table-column>
        <!-- <el-table-column prop="fStatusName"
                         label="状态">
        </el-table-column> -->
        <el-table-column prop="fStatus"
                         label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.fStatus === '1' ? 'success' : scope.row.fStatus === '0'? 'warning': 'danger'"
                    disable-transitions>{{scope.row.fStatusName}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="320">
          <template slot-scope="scope">
            <el-button @click="read(scope.row)"
                       type="success"
                       size="mini">查看</el-button>
            <el-button size="mini"
                       type="warning"
                       v-if="is_edit"
                       @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini"
                       type="success"
                       v-if="is_edit&&(scope.row.fStatus==0||scope.row.fStatus==10)"
                       @click="set(scope.row,1)">启用</el-button>
            <el-button size="mini"
                       type="info"
                       v-if="is_edit&&scope.row.fStatus==1"
                       @click="set(scope.row,10)">禁用</el-button>
            <el-button size="mini"
                       type="danger"
                       v-if="is_del"
                       @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageSearch.pageIndex"
                         @current-change="handlePage"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="adTempDialog">
      <el-dialog :title=" dialogTitle"
                 :visible.sync="dialogVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="60%">
        <el-form :inline="true"
                 :model="form"
                 :rules="rules"
                 ref="ruleForm"
                 :disabled="!isEdit"
                 label-width="140px">
          <el-row>
            <el-form-item label="广告模板名称："
                          prop="fLcdTmpName">
              <el-input v-model="form.fLcdTmpName"></el-input>
            </el-form-item>
            <el-form-item label="广告切换时间(秒)："
                          prop="fSwitchTime">
              <el-input v-model="form.fSwitchTime"></el-input>
            </el-form-item>
          </el-row>
          <fieldset>
            <legend>广告图片、视频</legend>
            <el-row>
              <el-upload :action="uploadUrl"
                         ref="uploadEl"
                         list-type="picture-card"
                         :file-list="uploadFileList"
                         name="files"
                         :on-success="handleFileSuccess"
                         :on-preview="handleFilePreview"
                         :before-upload="beforeAvatarUpload"
                         :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="imgDialogVisible"
                         title="文件详情"
                         :modal="false"
                         class="imgDialog"
                         v-dialogDrag>
                <img v-if="isVideo==false"
                     style="max-height:500px;max-width:100%;"
                     :src="dialogImageUrl"
                     alt="">
                <video v-else
                       style="max-height:500px;max-width:100%;"
                       :src="dialogVideoUrl"
                       controls="controls"></video>
              </el-dialog>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>待机页面</legend>
            <el-row>
              <el-form-item label="">
                <el-checkbox v-model="form.fIsShowSpaceNum">是否显示车位数</el-checkbox>
              </el-form-item>
              <el-form-item label="广告标题："
                            v-if="!form.fIsShowSpaceNum">
                <el-input v-model="form.fAdTitle"></el-input>
              </el-form-item>
              <el-form-item label="欢迎语："
                            v-if="!form.fIsShowSpaceNum">
                <el-input v-model="form.fAdWelMsg"></el-input>
              </el-form-item>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>支付页面</legend>
            <el-row>
              <el-form-item label="">
                <el-checkbox v-model="form.fIsShowDuration">停车时长</el-checkbox>
              </el-form-item>
              <el-form-item label="">
                <el-checkbox v-model="form.fIsShowInTime">入场时间</el-checkbox>
              </el-form-item>
              <el-form-item label="">
                <el-checkbox v-model="form.fIsShowCalcAmt">计费金额</el-checkbox>
              </el-form-item>
              <el-form-item label="">
                <el-checkbox v-model="form.fIsShowDedAmt">优惠金额</el-checkbox>
              </el-form-item>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>支付标志</legend>
            <el-row>
              <el-form-item label="">
                <el-checkbox v-model="form.fIsShowAliPayIcon">支付宝</el-checkbox>
              </el-form-item>
              <el-form-item label="">
                <el-checkbox v-model="form.fIsShowWxIcon">微信</el-checkbox>
              </el-form-item>
            </el-row>
          </fieldset>
        </el-form>
        <div class="dialog-footer">
          <el-button type="primary"
                     @click="submit('ruleForm')"
                     v-if="isEdit"
                     :loading="save_loading">{{save_msg}}</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as user from '../../api/user'
import * as park from '../../api/park'
import $ from 'jquery'
export default {
  data () {
    var validateSwitchTime = (rule, value, callback) => {
      if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
        callback(new Error('请填输入正整数的数字'))
      }
      callback()
    }
    return {
      pageSearch: {
        name: '',
        title: '',
        pageSize: 20,
        pageIndex: 1
      },
      uploadUrl: '',
      pageList: [],
      dialogImageUrl: '',
      dialogVideoUrl: '',
      isVideo: false,
      imgDialogVisible: false,
      uploadFileList: [],
      dialogVisible: false,
      save_loading: false,
      save_msg: '保存',
      loading: false,
      is_edit: false,
      is_del: false,
      isEdit: false,
      dialogTitle: '',
      form: {
        fileList: [],
        fLcdTmpID: '',
        fLcdTmpName: '',
        fSwitchTime: '',
        fIsShowSpaceNum: false,
        fAdTitle: '',
        fAdWelMsg: '',
        fIsShowDuration: false,
        fIsShowInTime: false,
        fIsShowCalcAmt: false,
        fIsShowDedAmt: false,
        fIsShowAliPayIcon: false,
        fIsShowWxIcon: false,
        fStatus: 0
      },
      rules: {
        fLcdTmpName: [
          { required: true, message: '请输入模板名称', trigger: 'blur' }
        ],
        fSwitchTime: [
          { required: true, message: '请输入切换时间', trigger: 'blur' },
          { validator: validateSwitchTime, trigger: 'blur' }
        ]
      },
      tableHeight: 0,
      total: 0
    }
  },
  methods: {
    setDefault () {
      this.form = {
        fileList: [],
        fLcdTmpID: '',
        fLcdTmpName: '',
        fSwitchTime: '',
        fIsShowSpaceNum: false,
        fAdTitle: '',
        fAdWelMsg: '',
        fIsShowDuration: false,
        fIsShowInTime: false,
        fIsShowCalcAmt: false,
        fIsShowDedAmt: false,
        fIsShowAliPayIcon: false,
        fIsShowWxIcon: false,
        fStatus: 0
      }
      if (this.$refs.uploadEl) {
        $('.el-upload-list>.el-upload-list__item').remove()
      }
      this.uploadFileList = []
    },
    handleAdd () {
      this.setDefault()
      this.dialogVisible = true
      this.dialogTitle = '新增广告模板'
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate()
        this.$refs['uploadEl'].clearFiles()
      })
      this.isEdit = true
    },
    beforeAvatarUpload (file) {
      if (file.type.indexOf('image') > -1) {
        const isLtImg = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/bmp')
        if (!isLtImg) {
          this.$message.error('上传图片只能是 JPG、PNG、BMP 格式!')
        }
        const isLt500KB = file.size / 1024 < 500
        if (!isLt500KB) {
          this.$message.error('上传图片大小不能超过 500K!')
        }
        return isLtImg && isLt500KB
      } else if (file.type.indexOf('video') > -1) {
        const isLtVideo = (file.type === 'video/mp4' || file.type === 'video/avi' || file.type === 'video/wmv')
        if (!isLtVideo) {
          this.$message.error('上传视频只能是 MP4、AVI、WMV格式!')
        }
        const isLt50M = file.size / 1024 / 1024 < 50
        if (!isLt50M) {
          this.$message.error('上传图片大小不能超过 50M!')
        }
        return isLtVideo && isLt50M
      } else {
        this.$message.error('上传只能是图片或视频格式!')
      }

      return false
    },
    handleFileSuccess (res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw)
      const el = this.$refs.uploadEl.$children[0].$el.children
      const lengths = this.$refs.uploadEl.$children[0].$el.children.length
      if (!res.status) {
        this.$message.error('上传失败，' + res.msg)
        el[lengths - 1].remove()
        return
      }
      if (file.raw.type === 'video/mp4' || file.raw.type === 'video/avi' || file.raw.type === 'video/wmv') {
        el[lengths - 1].children[0].remove()
        const video = document.createElement('video')
        video.src = res.data.file
        video.className = 'el-upload-list__item-thumbnail'
        video.style.objectFit = 'cover'
        el[lengths - 1].insertBefore(video, el[lengths - 1].children[0])
      }
      this.form.fileList.push(res.data)
    },
    handleFilePreview (file) {
      if ((file.raw && (file.raw.type === 'video/mp4' || file.raw.type === 'video/avi' || file.raw.type === 'video/wmv')) ||
        (file.type === '.mp4' || file.type === '.avi' || file.type === '.wmv')) {
        this.dialogVideoUrl = file.url
        this.isVideo = true
      } else {
        this.dialogImageUrl = file.url
        this.isVideo = false
      }
      this.imgDialogVisible = true
    },
    handleRemove (file, fileList) {
      var length = (this.form.fileList || []).length
      for (let i = 0; i < length; i++) {
        if (this.form.fileList[i].uid === file.ui) {
          this.form.fileList.splice(i, 1)
          break
        }
      }
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if ((this.form.fileList || []).length <= 0) {
          //   this.$message.error('请上传广告图片或视频')
          //   return false
          // }
          this.save_loading = true
          this.save_msg = '保存中…'
          console.log(this.form)
          park.saveAdTemp(this.form).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            if (res && res.data) {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.initData()
                  this.dialogVisible = false
                  this.$message({
                    type: 'success',
                    message: data.Msg
                  })
                } else {
                  this.$message.error(data.Msg)
                }
              }
            }
          })
        }
      })
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageSearch.pageIndex = index
      this.initData()
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    bindQuery () {
      this.initData()
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    view (row, isEdit) {
      this.setDefault()
      this.isEdit = isEdit
      // this.curRowInfo.op = op
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate()
        this.$refs['uploadEl'].clearFiles()
      })
      park.getAdTempInfo(row.fLcdTmpID).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.form.fLcdTmpID = data.Data.model.fLcdTmpID
              this.form.fLcdTmpName = data.Data.model.fLcdTmpName
              this.form.fSwitchTime = data.Data.model.fSwitchTime
              this.form.fAdTitle = data.Data.model.fAdTitle
              this.form.fAdWelMsg = data.Data.model.fAdWelMsg
              this.form.fIsShowSpaceNum = data.Data.model.fIsShowSpaceNum === '1'
              this.form.fIsShowDuration = data.Data.model.fIsShowDuration === '1'
              this.form.fIsShowInTime = data.Data.model.fIsShowInTime === '1'
              this.form.fIsShowCalcAmt = data.Data.model.fIsShowCalcAmt === '1'
              this.form.fIsShowDedAmt = data.Data.model.fIsShowDedAmt === '1'
              this.form.fIsShowAliPayIcon = data.Data.model.fIsShowAliPayIcon === '1'
              this.form.fIsShowWxIcon = data.Data.model.fIsShowWxIcon === '1'
              data.Data.fileList.forEach((el, index) => {
                const file = {
                  name: index,
                  url: el.fAdResUrl,
                  type: el.fAdSuffix,
                  response: { url: el.fAdResUrl }
                }
                this.uploadFileList.push(file)
                this.form.fileList.push({ 'file': el.fAdResUrl, 'fileMd5': el.fMD5Code })
                this.$nextTick(() => {
                  if (el.fAdSuffix === '.mp4' || el.fAdSuffix === '.avi' || el.fAdSuffix === '.wmv') {
                    const node = this.$refs.uploadEl.$children[0].$el.childNodes
                    node[index].children[0].remove()
                    const video = document.createElement('video')
                    video.src = el.fAdResUrl
                    video.className = 'el-upload-list__item-thumbnail'
                    video.style.objectFit = 'cover'
                    node[index].insertBefore(video, node[index].children[0])
                  }
                })
              })
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
      this.dialogTitle = '【' + row.fLcdTmpName + '】' + (isEdit ? '编辑广告模板' : '查看广告模板')
      this.dialogVisible = true
    },
    read (row) {
      this.view(row, false)
    },
    edit (row) {
      this.view(row, true)
    },
    set (row, status) {
      this.$confirm('请确认是否' + (status === 1 ? '启用' : '禁用') + '该模板【' + row.fLcdTmpName + '】?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        park.setAdTempStatus({ fLcdTmpID: row.fLcdTmpID, fStatus: status }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.initData()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    del (row) {
      this.$confirm('此操作将永久删除该模板【' + row.fLcdTmpName + '】, 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        park.deleteAdtemp(row.fLcdTmpID).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.initData()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    initData () {
      this.pageList = []
      this.loading = true
      park.getAdTempPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.pageList = data.Data.data || []
              this.total = data.Data.count
            }
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 1000000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.uploadUrl = data.Data.uploadUrl
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  computed: {

  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
.adTempDialog .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
.adTempDialog
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
.adTempDialog .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.adTempDialog .el-dialog__title {
  color: white;
}
.adTempDialog .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
/* .adTempDialog .el-dialog__body {
  padding: 0px;
} */
.adTempDialog .myParkInput {
  width: 220px;
}
.adTempDialog .el-row {
  margin-bottom: 20px;
}
.adTempDialog fieldset .el-row {
  margin-bottom: 0px;
}
.adTempDialog .el-radio {
  line-height: 2px;
}
.adTempDialog .is-disabled .el-input__inner,
.adTempDialog .is-disabled .el-textarea__inner {
  color: #606266;
}
.adTempDialog .fRemark_row .el-form-item__content {
  height: 60px !important;
}
.adTempDialog .parkTextArea .el-textarea__inner {
  width: 800px;
  height: 60px !important;
}
.adTempDialog .imgDialog .el-dialog__body {
  text-align: center;
  overflow: hidden;
}
</style>
<style scoped>
.search_list .t {
  color: #1eb1fb;
  font-weight: 700;
  min-height: 35px;
  line-height: 35px;
  font-size: 14px;
  padding: 0 7px;
}
#parkBaiduMap {
  float: left;
}
.search_list .a {
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #666;
  padding: 0 7px;
}
.search_list {
  height: 300px;
  width: 300px;
  overflow-y: auto;
  float: left;
}
.search_list .el-row {
  margin-top: 0px;
}
.search_list .el-row.selected,
.search_list .el-row:hover {
  background: #dcd9d9;
  cursor: pointer;
}
.parkMain_BaseInfo .el-select {
  width: 100%;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
/* legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
} */
fieldset {
  /* margin: 0 2px; */
  border: 1px solid silver;
}
.trans_row {
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}
.tab_foot {
  float: left;
  width: 110px;
  height: 80px;
  background: #ccc;
}
.btn_foot {
  float: left;
  text-align: right;
  padding: 20px;
}
.dialog-footer {
  text-align: right;
  padding: 20px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/park/adTempMain.vue